export enum SearchesBucketType {
  RECENT = 'recent_searches',
  FAVORITE = 'favorite_searches',
  SEEN = 'seen'
}
